<template>
  <div class="big">
    <div class="page_title flex between">
      <span>用户标签详情</span>
      <el-button
        type="primary"
        style="width:92px"
        size="medium"
        @click="back"
      >返回</el-button>
    </div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div>
          <span>标签名：</span>
          <span class="label_name">{{label_name}}</span>
          <span>标签类别：</span>
          <span class="label_name">{{label_type_name}}</span>
        </div>
        <div class="searchbox">
          <div class="flex">
            <div class="item">
              <span>用户昵称</span>
              <el-input
                v-model="nick_name"
                clearable
                @change="search"
                style="width:160px;margin:0 16px 0 6px"
              ></el-input>
            </div>
            <div class="item">
              <span>用户手机号</span>
              <el-input
                v-model="phone"
                clearable
                @change="search"
                style="width:160px;margin:0 16px 0 6px"
              ></el-input>
            </div>
            <div class="item">
              <el-button
                type="info"
                style="background-color: #eceff2; color: #747981;"
                @click="search"
              >查询</el-button>
            </div>
          </div>
          <el-button
            type="primary"
            :disabled=" module_id_array[0] ? !module_id_array.includes('1372') : false"
            @click="addDia"
          >添加用户到当前标签</el-button>
        </div>

        <div style="border: solid 1px #c9cbd6;">
          <el-table
            v-loading="tableLoading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="注册时间"
              prop="reg_time"
            ></el-table-column>
            <el-table-column label="头像">
              <template slot-scope="scope">
                <img
                  :src="scope.row.head_img"
                  alt=""
                  style="width:80px"
                >
              </template>
            </el-table-column>
            <el-table-column
              label="用户昵称"
              prop="nick_name"
            ></el-table-column>
            <el-table-column
              label="用户手机号"
              prop="phone"
            ></el-table-column>
            <el-table-column
              label="关联患者数"
              prop="patient_count"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled=" module_id_array[0] ? !module_id_array.includes('1371') : false"
                  @click="delUser(scope.row.user_id)"
                >从当前标签移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin:20px 0;text-align:center"
          ></el-pagination>
        </div>
        <!-- 添加用户弹窗 -->
        <el-dialog
          title="添加用户"
          :visible.sync="addDialog"
          width="720px"
          style="text-align: left;"
          :close-on-click-modal="false"
          @close="closeDia"
          center
        >
          <div style="padding: 20px">
            <div>
              <span>用户手机号</span>
              <el-input
                v-model="add_phone"
                size="medium"
                style="width: 140px;margin:0 10px 0 6px"
                @change="searchUser"
              />
              <el-button
                type="info"
                size="medium"
                style="background-color: #eceff2; color: #747981;"
                @click="searchUser"
              >查询</el-button>
            </div>
            <div style="border: solid 1px #c9cbd6;margin-top:16px">
              <el-table
                ref="multipleTable"
                :data="addData"
                tooltip-effect="dark"
                style="width: 100%"
                height="450px"
                :header-cell-style="{ background: '#F5F5F5' }"
                @selection-change="handleSelectionChange"
              >
                <el-table-column
                  type="selection"
                  width="50"
                >
                </el-table-column>
                <el-table-column
                  prop="reg_time"
                  label="注册时间"
                />
                <el-table-column
                  prop="nick_name"
                  label="用户昵称"
                />
                <el-table-column
                  prop="phone"
                  label="用户手机号"
                />
                <el-table-column
                  label="关联患者数"
                  prop="patient_count"
                >
                </el-table-column>
              </el-table>
            </div>
            <div style="text-align:center;margin:20px 0">
              <el-pagination
                @size-change="userSizeChange"
                @current-change="userCurrentChange"
                :current-page="userpage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="usersize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="userNum"
              ></el-pagination>
            </div>
            <div style="text-align:center;">
              <el-button
                plain
                size="medium"
                @click="addDialog=false"
              >取 消</el-button>
              <el-button
                type="primary"
                @click="addUser"
                size="medium"
              >确 定</el-button>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import ChooseDoctor from '@/components/chooseDoctor/index';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      nick_name: '',
      phone: '',
      userpage: 1,
      usersize: 10,
      userNum: 0,
      addData: [],
      addDialog: false,
      add_phone: '',
      user_id: '',
      label_id: this.$route.query.label_id,
      label_name: this.$route.query.label_name,
      label_type_name: this.$route.query.label_type_name
    };
  },
  components: {
    ChooseDoctor
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        label_id: this.label_id,
        nick_name: this.nick_name,
        phone: this.phone
      };
      this.axios
        .post('platform/patient/getUserLabelDetail', data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.reg_time = dayjs
                .unix(item.reg_time)
                .format('YYYY-MM-DD HH:mm:ss');
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //获取添加用户列表
    getAddList() {
      let data = {
        phone: this.add_phone,
        page: this.userpage,
        pageNumber: this.usersize
      };
      this.axios.post('platform/patient/getUserList', data).then((res) => {
        this.userNum = res.data.total;
        this.addData = res.data.list.map((item) => {
          item.reg_time = dayjs
            .unix(item.reg_time)
            .format('YYYY-MM-DD HH:mm:ss');
          return item;
        });
      });
    },
    searchUser() {
      this.userpage = 1;
      this.getAddList();
    },
    //每页数据的条数
    userSizeChange(size) {
      this.usersize = size;
      this.getAddList();
    },
    //当前第几页
    userCurrentChange(currentPage) {
      this.userpage = currentPage;
      this.getAddList();
    },
    //多选
    handleSelectionChange(val) {
      let selection = val.map((item) => {
        return item.user_id;
      });
      this.user_id = selection.toString();
    },
    //添加用户弹窗
    addDia() {
      this.getAddList();
      this.addDialog = true;
    },
    //添加用户
    addUser() {
      if (!this.user_id) {
        this.$message.error('请选择用户');
        return false;
      }
      let data = {
        user_id: this.user_id,
        label_id: this.label_id
      };
      this.axios.post('platform/patient/addLabelUser', data).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功');
          this.closeDia();
          this.getList();
        }
      });
    },
    closeDia() {
      this.user_id = '';
      this.add_phone = '';
      this.selection = [];
      this.addDialog = false;
      this.getList();
    },
    //删除
    delUser(user_id) {
      this.$confirm('您确定从当前标签移除该用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let data = {
            user_id,
            label_id: this.label_id
          };
          this.axios
            .post('platform/patient/removeLabelUser', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('移除成功');
                if (!(this.tableData.length - 1) % this.pagesize) {
                  this.currentPage =
                    this.currentPage == 1 ? 1 : this.currentPage - 1;
                }
                this.getList();
              }
            });
        })
        .catch(() => {});
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.searchbox {
  display: flex;
  align-items: center;
  margin: 20px 0;
  justify-content: space-between;
  .item {
    display: flex;
    align-items: center;
  }
}
.label_name {
  font-size: 15px;
  font-weight: 700;
  margin: 0 40px 0 6px;
}
</style>
